import axios from 'axios'
import { getToken } from '@/utils/auth'
// import store from '@/store'
import i18n from '@/language'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (getToken()) {
      config.headers['Authorization'] = `Bearer ${getToken()}`
    }
    config.headers['X-Requested-With'] = 'wallet-user'

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data

    if (res.message === 'gone') {
      window.location = '/terminated'
    } else {
      return res
    }
  },
  error => {
    let message = error
    if (
      error &&
      error.response &&
      error.response.data &&
      error.response.data.message
    ) {
      if (error.response.data.message === 'invalid-token')
        window.location = '/login'
      else if (i18n.te('errorMsg.' + error.response.data.message)) {
        message = i18n.t('errorMsg.' + error.response.data.message)
      } else {
        message = error.response.data.message
      }
    }

    if (message === 'ไม่สามารถยืนยันตัวตนได้') {
      window.location.href = '/login'
    }

    return Promise.reject(message)
  }
)

export default service
